<!--美育浸润-视频详情-->
<template>
    <div class="guide-ext-container" v-loading="loading">
        <div class="museum-title-container">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container" :title="videoInfo.title">{{videoInfo.title}}</div>
                <div class="l-b-museum-title-container">视频详情</div>
            </div>
            <div class="r-museum-title-container">
                <div class="back-btn-container" @click="backPage">⇦返回</div>
            </div>
        </div>

        <!-- 主体内容 -->
        <div class="videoinfo-main">
            <!-- 左侧工具栏 -->
            <div class="videoinfo-toolbar">
                <div class="toolbar-item" :class="{ active: hasFile }" @click="handleMaterial">
                    <el-icon class="toolbar-icon"><Document /></el-icon>
                    <span class="toolbar-text">资料</span>
                </div>
            </div>

            <!-- 资料弹框 -->
            <el-dialog v-model="materialDialogVisible" title="资料列表" width="600px" :close-on-click-modal="false">
                <div class="file-list" v-if="fileList && fileList.length > 0">
                    <div class="file-item" v-for="(item, index) in fileList" :key="index" @click="handleFileClick(item)">
                        <el-icon class="file-icon"><Document /></el-icon>
                        <span class="file-name" :title="item.fileName || item.name">{{ item.fileName || item.name || '未命名文件' }}</span>
                    </div>
                </div>
                <div class="file-empty" v-else>暂无资料</div>
            </el-dialog>

            <!-- 右侧视频 -->
            <div class="videoinfo-content">
                <div class="video-player-box" :id="playerWrapId"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {infoHumVideo} from "@/api/admin/museum";

export default {
    name: "beautyVideoInfo",
    data() {
        return {
            loading:false,
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            videoInfo:{},
            fileList:[],
            materialDialogVisible:false,
            player:null,
            /*播放器容器id：组件被多处同时挂载，需保证页面内唯一*/
            playerWrapId:'beauty-video-player-' + Math.random().toString(36).substring(2, 10),
        }
    },
    computed: {
        hasFile() {
            return this.fileList && this.fileList.length > 0;
        }
    },
    props:{
        videoId:{
            type: [String,Number],
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.destroyPlayer();
            this.queryVideoInfo();
        },
    },
    created() {
        this.queryVideoInfo();
    },
    mounted(){},
    methods: {
        /*查询视频详情*/
        queryVideoInfo(){
            if (!this.videoId) return;
            this.loading = true;
            infoHumVideo({videoId:this.videoId}).then(res => {
                if (res.data.code===1){
                    this.videoInfo = res.data.data || {};
                    this.fileList = this.videoInfo.fileList || [];
                    this.playVideo();
                }else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /*视频播放*/
        playVideo(){
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#' + this.playerWrapId,
                vid: this.videoInfo.videoId,
            });
        },
        destroyPlayer() {
            if (this.player) {
                this.player.destroy();
                this.player = null;
            }
        },
        /*资料*/
        handleMaterial() {
            this.materialDialogVisible = true;
        },
        handleFileClick(item) {
            const url = item.fileUrl || item.url || item.filePath || "";
            if (url) {
                window.open(url, "_blank");
            } else {
                this.$message.info("该文件暂无可下载地址");
            }
        },
        backPage(){
            this.destroyPlayer();
            this.$emit('back-model-page', 'beautyVideoList');
        }
    },
    beforeUnmount() {
        this.destroyPlayer();
    }
}
</script>

<style scoped>
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 0 28px;
    box-sizing: border-box;
}
.l-museum-title-container{
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #0d55a4;
    font-size: 18px;
    line-height: 1.4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    display: flex;
    align-items: center;
    flex-shrink: 0;
}
.back-btn-container{
    height: 32px;
    padding: 0 14px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
}

/* 主体内容 */
.videoinfo-main{
    flex: 1;
    min-height: 0;
    width: calc(100% - 56px);
    margin: 0 28px;
    background-color: #ffffff;
    border: 1.5px solid #0d55a4;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
}

/* 左侧工具栏 */
.videoinfo-toolbar{
    width: 70px;
    flex-shrink: 0;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #ffffff;
}
.toolbar-item{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #4b5563;
}
.toolbar-item:hover{
    color: #0d55a4;
    background-color: #fff7f0;
}
.toolbar-item.active{
    color: #0d55a4;
}
.toolbar-icon{
    font-size: 22px;
    margin-bottom: 6px;
}
.toolbar-text{
    font-size: 13px;
}

/* 右侧内容 */
.videoinfo-content{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
}
.video-player-box{
    width: 100%;
    background-color: #000000;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
}

/* 资料弹框文件列表 */
.file-list{
    max-height: 400px;
    overflow-y: auto;
}
.file-item{
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    transition: all 0.2s ease;
}
.file-item:hover{
    background-color: #fff7f0;
}
.file-icon{
    font-size: 20px;
    color: #0d55a4;
    margin-right: 10px;
    flex-shrink: 0;
}
.file-name{
    flex: 1;
    font-size: 14px;
    color: #1f2937;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.file-empty{
    padding: 40px 0;
    text-align: center;
    font-size: 14px;
    color: #9ca3af;
}
</style>
